import React, { Component } from "react";
import "../assests/css/shimmer.css";
import _ from "lodash";

class NotificationShimmer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderShimmer(arr) {
    return _.map(arr, (arr, index) => {
      return (
          <div className="usershimmerwrapper" key={index}>
            <div className="profile shine"
              style={{ height: '40px', width: '40px' }}>
            </div>
            <div className="textline">
              <span className="shine" style={{height: '5px',marginTop: '9px'}}></span>
              <span className="shine" style={{height: '5px',marginTop: '9px'}}></span>
              <span className="shine" style={{height: '5px',marginTop: '9px'}}></span>
            </div>
          </div>
      );
    });
  }

  render() {
    // console.log(this.props.count);
    var arr = new Array(this.props.count).fill("Shimmer");
    // console.log(arr);
    return <div>
      {this.renderShimmer(arr)}
    </div>;
  }
}

export default NotificationShimmer;
